import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { LANGUAGES, translate } from "../lib/i18n";

const LangContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    if (typeof window === "undefined") return "en";
    const stored = localStorage.getItem("sanyog_lang");
    if (stored && LANGUAGES.some((l) => l.code === stored)) return stored;
    // Auto-detect browser language on first visit
    const nav = (navigator.language || "en").toLowerCase();
    if (nav.startsWith("hi")) return "hi";
    if (nav.startsWith("mr")) return "mr";
    return "en";
  });

  useEffect(() => {
    try { localStorage.setItem("sanyog_lang", lang); } catch {}
    if (typeof document !== "undefined") document.documentElement.lang = lang;
  }, [lang]);

  const setLang = useCallback((code) => setLangState(code), []);
  const t = useCallback((key) => translate(key, lang), [lang]);

  return (
    <LangContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext) || { lang: "en", setLang: () => {}, t: (k) => k, languages: LANGUAGES };
}
